<template>
  <v-app>
    <template>
      <v-toolbar flat style="flex: none;">
        <v-toolbar-title>Giá cả thị trường</v-toolbar-title>
        <!-- <v-spacer/> -->
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ngày cập nhật"
          v-mask="'##/##/####'"
          :placeholder="placeholder"
          single-line
          hide-details
          clearable
          class="shrink mr-4"
        />
        <i class="mr-4">hoặc</i>
        <DatePickerMonth
          v-model="byMonthYear"
          :label="'Tháng-Năm'"
          :filled="true"
          :hideDetails="true"
        >
          
        </DatePickerMonth>
        <v-spacer/>
        <ListPrice 
          :showDialog="priceDetailDialog"
          :priceDetail="priceDetail"
          @cancelled="onPriceDetailCancelled"
        />
        <v-btn
          color="success"
          dark
          class="mb-2 mr-2"
          :to="{path: '/admin/market-import'}"
        >
          <v-icon left>mdi-microsoft-excel</v-icon>
          Thêm từ Excel
        </v-btn>
        <v-btn
          color="primary"
          dark
          class="mb-2"
          v-on:click="showDialog()"
        >
          <v-icon left>mdi-plus</v-icon>
          thêm mới
        </v-btn>
        <Form 
          :showDialog="dialog" 
          :item="item" 
          @confirmed="onConfirmed" 
          @cancelled="onCancelled"
        />
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
              <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <div class="tabs">
        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Bảng giá</a>
        <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Biểu đồ</a>
      </div>
      <v-divider/>
    </template>
    <MarketChart v-if="activetab==2" />
    <v-data-table
      v-if="activetab == 1"
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:[`item.id`]="{ index }">
        {{ (perPage * (page-1)) +  (index+1) }}
      </template>
      <template v-slot:item.ngay_cap_nhat="{ item }">
        Thứ {{item._dayname_marketprice}}, {{item.ngay_cap_nhat}}
      </template>
      <template v-slot:item._created_at="{ item }">
        Thứ {{item._dayname}}, {{item._created_at}}
      </template>
      <template v-slot:item.price="{ item }">
        {{ item.price | currency('đ') }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap;">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="blue"
                v-bind="attrs"
                v-on="on"
                @click="viewListPrice(item)"
              >
                <v-icon>
                  mdi-information-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Chi tiết bảng giá</span>
          </v-tooltip>
          <v-btn
            icon
            color="primary"
            @click="download(item)"
          >
            <v-icon>
              mdi-download
            </v-icon>
          </v-btn>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="orange"
                v-bind="attrs"
                v-on="on"
                @click="getAttachment(item)"
              >
                <v-icon>
                  mdi-attachment
                </v-icon>
              </v-btn>
            </template>
            <span>File tải lên</span>
          </v-tooltip>
          <v-btn
            icon
            color="pink"
            @click="deleteItem(item)"
          >
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import Form from '@/views/admin/markets/Form';
  import ListPrice from '@/views/admin/markets/ListPrice';
  import MarketChart from '@/views/admin/markets/MarketChart';
  import FileSevice from '@/services/File';
  import DatePickerMonth from '@/components/common/DatePickerMonth.vue';
  import { mapActions } from 'vuex';
  export default {
    components: {
      Form,
      ListPrice,
      MarketChart,
      DatePickerMonth
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      priceDetailDialog: false,
      searchInput: '',
      searchTimeout: null,
      sortDesc: true,
      sortBy: "ngay_cap_nhat",
      headers: [
        { text: 'STT', value: 'rn' },
        { text: 'Tuần', value: '_week' },
        { text: 'Ngày bảng giá', value: 'ngay_cap_nhat' },
        { text: 'Ngày thao tác', value: '_created_at' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      items: [],
      editedIndex: -1,
      item: {},
      options: {},
      priceDetail: {},
      activetab: 1,
      placeholder: `Vd: 01/01/${(new Date()).getFullYear()}`,
      search: '',
      byMonthYear: ''
    }),
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.initialize();
        }, 1000);
      },
      byMonthYear(){
        this.initialize();
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        app.loading = true;
        const { page, itemsPerPage, sortBy, sortDesc } = app.options;
        let pageNumber = page;

        let _month = null;
        let _year = null;
        if(this.byMonthYear) {
          let month_year = this.byMonthYear.split("/");
          if(month_year.length > 1) {
            _month = month_year[0];
            _year = month_year[1];
          }
        }

        let request = {
          params: {
            day: null,
            month: _month,
            year: _year,
            size: itemsPerPage,
            page: pageNumber
          }
        };
        if(app.search){
          request.params.day = app.search.split('/')[0];
          request.params.month = app.search.split('/')[1];
          request.params.year = app.search.split('/')[2];
        }
        axios.get("api/v1/public/get-market-date", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.page = response.data.current_page;
            app.perPage = response.data.per_page;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
            app.loading = false;
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      onPriceDetailCancelled(){
        this.priceDetailDialog = false;
      },
      viewListPrice(item) {
        this.priceDetail=item;
        this.priceDetailDialog = true;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        let request = {
          params: {
            date: app.item.ngay_cap_nhat
          }
        };
        axios.get('api/v1/market-delete-all-by-date', request)
          .then(function (resp) {
            app.items = app.items.filter(val => val.ngay_cap_nhat !== app.item.ngay_cap_nhat);
            app.closeDelete();
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      parseDate(d){
        return d.replaceAll('/', '');
      },
      download(date) {
        const app =this;
        let ngay_cap_nhat = app.parseDate(date.ngay_cap_nhat);
        app.loading = true;
        axios.get(
          `api/v1/public/market-export/${ngay_cap_nhat}`,
          {responseType: 'arraybuffer'}
        )
          .then(function (response) {
            FileSevice.download(response.data, `${ngay_cap_nhat}.xlsx`);
            app.loading = false;
            app.openSnackbar({ 
              type: 'success',
              body: 'Tải về thành công!'
            });
          })
          .catch(function (error) {
            app.loading = false;
            app.openSnackbar({ type: 'error' });
          });
      },
      getAttachment(date) {
        const app =this;
        let file = date.file_import.file;
        let params = {
          file: file
        };
        app.loading = true;
        axios.post(
          "api/v1/get-file-imported",
          params,
          {responseType: 'arraybuffer'}
        )
          .then(function (response) {
            FileSevice.download(response.data, `${file}`);
            app.loading = false;
            app.openSnackbar({ 
              type: 'success',
              body: 'Tải về thành công!'
            });
          })
          .catch(function (error) {
            app.loading = false;
            app.openSnackbar({ type: 'error' });
          });
      },
      removeYearMonthFilter(){
        this.byMonthYear = null;
        this.initialize();
      }
    }
  }
</script>
<style scoped>
  .tabs {
    overflow: hidden;
    margin-left: 20px;
    margin-bottom: -2px;
    z-index: 1;
  }
  .tabs ul {
    list-style-type: none;
    margin-left: 20px;
  }
  .tabs a{
    float: left;
    cursor: pointer;
    padding: 4px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #f1f1f1;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
  }
  .tabs a:last-child { 
    border-right: 1px solid #ccc;
  }
  .tabs a:hover {
    background-color: #aaa;
    color: #fff;
  }
  .tabs a.active {
    background-color: #fff;
    color: #484848;
    border-bottom: 2px solid #fff;
    cursor: default;
  }
</style>